import get from 'lodash/get';

import { CreateFromPropsFunction, CSSProps } from '../types';

const createFromProps: CreateFromPropsFunction = (utilFunction, paramName) => (
  props: CSSProps,
) => utilFunction(get(props, 'theme'), get(props, paramName));
export default createFromProps;
